import { render, staticRenderFns } from "./DetailForm.vue?vue&type=template&id=6456c3bd&"
import script from "./DetailForm.vue?vue&type=script&lang=js&"
export * from "./DetailForm.vue?vue&type=script&lang=js&"
import style0 from "./DetailForm.vue?vue&type=style&index=0&id=6456c3bd&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports